import { useEffect } from 'react';
import { useState } from 'react';
import { ethers } from 'ethers';
import './App.css';

import contract from './contracts/Kuono.json';
const contractAddress = "0x242A9646445Ff4eB55689c6Da84D062fEB58daD8"

const abi = contract.abi;
var shit="";

async function Nof() {
var pylly = document.createElement('input');
var many = document.createElement('p');
many.textContent = "How many? (Max 50):";
pylly.value = "1";
pylly.id = "pcs";
pylly.type = "text";
pylly.pattern = "[0-9]*";
pylly.min = "1";
pylly.max = "50";
document.getElementById("shit").append(many);
document.getElementById("shit").append(pylly);
}

async function log(text) {
document.getElementById("info").innerHTML = "";
var pylly = document.createElement('p');
pylly.textContent = text;
pylly.id = "stats";
document.getElementById("info").append(pylly);
}

async function load() {
var load = document.createElement('div');
load.className = "loader";
load.id = "stats";
document.getElementById("info").append(load);
}

function App() {
const [currentAccount, setCurrentAccount] = useState(null);

const checkWalletIsConnected = async () => {
const { ethereum } = window;
if (!ethereum){
shit = "Metamask Wallet is required!";
return;
} else {
shit = "Wallet found!";
console.log(shit);
log(shit);
}
const accounts = await ethereum.request({ method: 'eth_accounts' });
if(accounts.length !== 0){
const account = accounts[0];
shit = "Authorized account found! "+account;
console.log(shit);
log(shit);
setCurrentAccount(account);
Nof();
} else {
shit = "Authorized account not found! ";
console.log(shit);
log(shit);
}
}

const connectWalletHandler = async () => {
const { ethereum } = window;
if (!ethereum){
alert("Install Metamask wallet!"); }
try {
const accounts = await ethereum.request({ method: 'eth_requestAccounts' });
shit = "Account found! "+accounts[0];
console.log(shit);
log(shit);
setCurrentAccount(accounts[0]);
Nof();
} catch (err) {
console.log(err)
}
}

const mintNftHandler = async () => {
try {
const { ethereum } = window;
if (ethereum) {
shit = "Checking funds...";
console.log(shit);
log(shit);
load();
//const provider = new ethers.providers.Web3Provider(ethereum);
const provider = new ethers.BrowserProvider(ethereum);
const signer = await provider.getSigner();
const nftContract = new ethers.Contract(contractAddress, abi, signer);
const balance = await provider.getBalance(currentAccount);
const eths = ethers.formatEther(balance);
//const eths = ethers.utils.formatEther(balance);
const pcs = document.getElementById("pcs").value;
//const gasprice = await provider.getGasPrice();
const gasprice = await provider.send("eth_gasPrice", []);
//const gasprice = await provider.getFeeData();
//const gasprice = feeData.maxFeePerGas;
const gas = ethers.formatEther(gasprice);
//const gas = ethers.utils.formatEther(gasprice);
const price = pcs*0.05;
const net = await provider.getNetwork();
const total = await nftContract.totalSupply();
const total2 = ethers.formatUnits(total,"wei");
//const total2 = ethers.utils.formatUnits(total,"wei");
const avail = 1050-total2;
//console.log(avail);
console.log(net.chainId);
if (net.chainId == 1) {
if (pcs > 50){
shit = "Maximum mints exceeded! (50 tokens)";
console.log(shit);
log(shit);
} else if (pcs > avail) {
shit = "Sorry! Only "+avail+" tokens left!";
console.log(shit);
log(shit);
} else if (eths > price+gas) {
shit = "Initialize payment";
console.log(shit);
log(shit);
let nftTxn = await nftContract.mintNFTs(pcs, { value: ethers.parseEther(price.toString()) });
//let nftTxn = await nftContract.mintNFTs(pcs, { value: ethers.utils.parseEther(price.toString()) });
shit = "Mining... please wait";
console.log(shit);
log(shit);
load();
await nftTxn.wait();
shit = `Mined, see transaction: https://etherscan.io/tx/${nftTxn.hash}`;
console.log(shit);
log(shit);
} else {
shit = "Insufficient funds: "+eths+" of "+price.toString()+" eth!";
console.log(shit);
log(shit);
}
} else {
shit = "Wrong network!";
console.log(shit);
log(shit);
}
} else {
shit = "Ethereum object does not exist";
console.log(shit);
log(shit);
}
} catch (err) {
console.log(err);
}
}

	  const connectWalletButton = () => {
		      return (
			            <button onClick={connectWalletHandler} className='cta-button connect-wallet-button'>
			              Connect Wallet
			            </button>
			          )
		    }

	  const mintNftButton = () => {
		      return (
			            <button onClick={mintNftHandler} className='cta-button mint-nft-button'>
			              Mint Kuono NFT
			            </button>
			          )
		    }

	  useEffect(() => {
		      checkWalletIsConnected();
		    }, [])

	  return (
		      <div className='main-app'>
		        <h1>Mint your Kuono NFT now!</h1>
		        <p>Price: 0.05 eth / token + gas</p>
		  <div id="shit"></div>
		        <div>
		  {currentAccount ? mintNftButton() : connectWalletButton()}
		        </div>
		      <center>
		      <div id='info'>
		        </div>
		  </center>
		      </div>
		    )
}

export default App;
